import React from 'react';
import withNavigate from '../../../core/withNavigate';
import { ShelfStoreProfile } from '../../../components/stores/store/store';
import { InventoryTable } from '../../../components/stores/store/elements';
import { expirationColumn } from '../elements';
import MIMESA_CONFIG from '../config';

/**
 * Mimesa's store (PDV) detail: the base page with the expiration date ("Vencimiento") of each
 * product in the last store check's warehouse inventory.
 */
export class MimesaStoreProfile extends ShelfStoreProfile {
    renderInventory(lastCheck) {
        if (!lastCheck?.inventory) return null;
        return (
            <InventoryTable
                inventory={lastCheck.inventory}
                loading={this.state.elementsLoading}
                extraColumns={[expirationColumn(MIMESA_CONFIG.expiryWarningDays)]}
            />
        );
    }
}

export default withNavigate(MimesaStoreProfile);
